import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "../Styles/Dashboard.css";
import Axios from 'axios';
import UserProfileHeader from './UserProfileHeader';
import ErrorBoundary from '../Components/ErrorBoundary';
import { toast, ToastContainer } from 'react-toastify';

const Dashboard = () => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const email = localStorage.getItem('userEmail') || '';

    // If no email, leave dashboard cleanly and ask user to log in again.
    if (!email) {
      // optional toast here if you want:
      // toast.error('Session expired. Please log in again.');
      navigate('/login?next=' + encodeURIComponent('/dashboard'), { replace: true });
      return;
    }

    // Store IP and location
    Axios.get('https://ipapi.co/json/')
      .then((response) => {
        const ipAddress = response.data.ip;
        const ipLocation = {
          city: response.data.city,
          region: response.data.region,
          country: response.data.country_name,
          latitude: response.data.latitude,
          longitude: response.data.longitude
        };

        Axios.post(`/store_ip_address`, {
          email,
          ipAddress,
          ipLocation: JSON.stringify(ipLocation)
        }).catch((error) => {
          console.error("An error occurred while storing IP information.", error);
        });
      }).catch((error) => {
        console.error("Failed to fetch IP information.", error);
      });

    // Load user role
    const fetchRole = () => Axios.post(`/get_user_role`, { email })
      .then((response) => {
        if (response.data?.success) {
          setIsAdmin(!!response.data.is_admin);
        } else {
          // Retry once after a short delay; if it still fails, show the toast
          setTimeout(() => {
            Axios.post(`/get_user_role`, { email })
              .then((r2) => {
                if (r2.data?.success) setIsAdmin(!!r2.data.is_admin);
                else toast.error("Failed to retrieve user role");
              })
              .catch(() => toast.error("An error occurred while fetching user role."));
          }, 300);
        }
      }).catch(() => {
        toast.error("An error occurred while fetching user role.");
      });
    fetchRole();

    // Show toast for login success
    const loginSuccessMessage = localStorage.getItem('loginSuccessMessage');
    if (loginSuccessMessage) {
      toast.success(loginSuccessMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
      localStorage.removeItem('loginSuccessMessage');
    }
  }, []);

  return (
    <div className="dashboard">
      <ErrorBoundary>
        <UserProfileHeader isAdmin={isAdmin} />
      </ErrorBoundary>
      <ToastContainer position="top-right" />
    </div>
  );
};

export default Dashboard;
